import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Text } from '@chakra-ui/react';
import { Pagination } from '@netiva/classifieds-ui';

import { usePagination } from '@/hooks';

import { ConversationListItem as Item } from '../types';
import { ConversationListItem } from './ConversationListItem';

export type ConversationListProps = {
  conversations: Item[];
  selectedId?: number;
  totalPages: number;
  onSelect: (id: number) => void;
};

export const ConversationList: FC<ConversationListProps> = memo(function ConversationList({
  conversations,
  selectedId,
  totalPages,
  onSelect,
}) {
  const { t } = useTranslation();
  const paginationProps = usePagination({ totalPages });

  if (!conversations.length) {
    return (
      <Box p={4}>
        <Text color="neutral.500">{t('messages.list.empty')}</Text>
      </Box>
    );
  }

  return (
    <Box>
      {conversations.map((conversation) => (
        <ConversationListItem
          key={conversation.id}
          conversation={conversation}
          isSelected={conversation.id === selectedId}
          onSelect={onSelect}
        />
      ))}
      <Box p={2}>
        <Pagination {...paginationProps} />
      </Box>
    </Box>
  );
});
